import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { IQueueHealthResponse } from 'types/api/operationsAimApi.interface'
import { IOpsQueueHealthSlice } from 'types/opsQueueHealth.interface'
import { baseUrl } from 'utils/axios'
import { handleErrors } from 'utils/helpers'
import { USE_OPS_MOCKS } from 'pages/Operations/Shared/opsControl'
import { DEMO_QUEUE_HEALTH } from 'pages/Operations/Shared/opsApiDemoCore'

const initialState: IOpsQueueHealthSlice = {
  isLoading: false,
  siteRollup: [],
  planHealth: null,
}

export const getSiteQueueHealth = createAsyncThunk(
  'opsQueueHealth/getSiteQueueHealth',
  async (_, thunkAPI) => {
    if (USE_OPS_MOCKS) return DEMO_QUEUE_HEALTH
    try {
      const resp: AxiosResponse<IQueueHealthResponse[]> = await baseUrl.get('aim-operations/queue-health')
      return resp.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

export const getPlanQueueHealth = createAsyncThunk(
  'opsQueueHealth/getPlanQueueHealth',
  async (planId: number, thunkAPI) => {
    if (USE_OPS_MOCKS) {
      return DEMO_QUEUE_HEALTH.find((q) => q.planId === planId) || DEMO_QUEUE_HEALTH[0]
    }
    try {
      const resp: AxiosResponse<IQueueHealthResponse> = await baseUrl.get(
        `aim-operations/plan/${planId}/queue-health`,
      )
      return resp.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

const opsQueueHealthSlice = createSlice({
  name: 'opsQueueHealth',
  initialState,
  reducers: {
    clearQueueHealth: (state) => {
      state.siteRollup = []
      state.planHealth = null
    },
  },
  extraReducers: {
    [getSiteQueueHealth.pending.type]: (state) => {
      state.isLoading = true
    },
    [getSiteQueueHealth.fulfilled.type]: (state, { payload }: { payload: IQueueHealthResponse[] }) => {
      state.isLoading = false
      state.siteRollup = payload || []
    },
    [getSiteQueueHealth.rejected.type]: (state, action) => {
      state.isLoading = false
      handleErrors(action.payload)
    },
    [getPlanQueueHealth.fulfilled.type]: (state, { payload }: { payload: IQueueHealthResponse }) => {
      state.planHealth = payload
    },
    [getPlanQueueHealth.rejected.type]: (state, action) => handleErrors(action.payload),
  },
})

export const { clearQueueHealth } = opsQueueHealthSlice.actions
export default opsQueueHealthSlice.reducer
